/**************************************************
 * Nombre:       Detalle_Educacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Checkbox, Divider, Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import linea from "../../../Recursos/Iconos/ic_raya.svg";
import {theme} from "../../../Tema";
import Tarjeta_Fecha from "../../Tarjetas/Tarjeta_Fecha";
import Tarjeta_Modalidad from "../../Tarjetas/Tarjeta_Modalidad";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Inscripcion from "../../Formularios/Formulario_Inscripcion";
import {MonetizationOn} from '@mui/icons-material'
import {useState} from "react";
import {formatoMoneda} from "../../../Utilidades/formatoMoneda";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import logo from '../../../Recursos/logo_redondo.svg'
import {enviarPeticion} from "../../../Modulo_Peticiones/Peticiones/enviarPeticion";


const Detalle_Educacion = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, terminar, iniciarCarga} = useCargador({logoRedondo: logo, funcionUno: setEntidad})
    const [cargando, setCargando] = useState(false)
    const [acepto, setAacepto] = useState(true)


    const subirDatos = async () => {

        let entidad = await obtenerEntidad();
        entidad.estado = 'Preinscrito'
        entidad.idCurso = item.id
        entidad.nombreCurso = item.nombre
        entidad.parrafo = item.parrafo
        iniciarCarga('Subiendo Datos')
        setCargando(true)

        let dox = await guardarDoc('inscritos', entidad)
        if (dox.res) {
            // enviar Correo
            await enviarPeticion({datos: entidad, flujo: 'enviar_email'})
            // enviar Notificacion
            await enviarPeticion({datos: entidad, flujo: 'notificacion'})
            //
            terminar({aviso: 'Datos subidos correctamente, se le enviara un correo para con las instrucciones para finalizar su registro'})
        } else {
            terminar({aviso: 'Algo salio mal, porfavor intenta nuevamente', variante: 'error'})
        }

        setCargando(false)


    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: 'linear-gradient(180deg, rgba(48, 51, 118, 0.76) 0%, rgba(48, 51, 118, 0.76) 100%),  url(' + item.img + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'top center',
                pt: 15,
                mt: -18,
                pb: 0
            }}
        >

            <Cargador/>

            <Avisos/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}}
                      sx={{justifyContent: 'flex-start', alignItems: 'flex-start', mt: 8}} spacing={2}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 8}}
                        sx={{color: '#fff'}}
                        spacing={0}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography
                                sx={{
                                    fontFamily: NEGRITA,
                                    fontSize: !masSM ? 18 : 24,
                                    fontWeight: 400,
                                    lineHeight: 1.1
                                }}>{item.resolucion}
                                <img src={linea} width={40} height={'auto'} alt={'linea'}
                                     style={{marginTop: -7, marginBottom: 7, paddingLeft: 5}}/>
                            </Typography>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography
                                sx={{
                                    fontFamily: NEGRITA,
                                    fontSize: sCell ? 32 : 48,
                                    fontWeight: 400,
                                    lineHeight: 1.1,
                                    textTransform: 'uppercase',
                                }}>
                                {item.nombre}
                            </Typography>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography
                                sx={{fontSize: sCell ? 16 : 18, fontWeight: 300, lineHeight: 1.5}}>
                                {item.parrafoDetalle}
                            </Typography>
                        </Grid>


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 10}}
                            sx={{
                                backgroundColor: '#fff',
                                borderRadius: 2,
                                p: 2,
                                mt: 6,
                                color: theme.palette.primary.main
                            }}
                            spacing={2}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Fecha item={item}/>
                            </Grid>

                            {!sCell &&
                                <Divider orientation="vertical" flexItem/>
                            }

                            {item && item.adicionales && item.adicionales[0] &&
                                <Grid container size={{xs: 12, sm: 12, md: 6}}
                                      sx={{justifyContent: 'flex-start', pl: sCell ? 0 : 2}}>
                                    <Tarjeta_Modalidad item={item.adicionales[0]}/>
                                </Grid>
                            }

                        </Grid>


                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 4}}
                        sx={{
                            backgroundColor: '#fff',
                            p: 2,
                            borderRadius: 4,
                            color: theme.palette.primary.main,
                            boxShadow: 4,
                            mb: -26
                        }}
                        spacing={0}
                    >

                        {item && item.valores && item.valores.map(valor => (
                            <Grid
                                container
                                justifyContent={'space-between'}
                                alignItems={'flex-start'}
                                size={{xs: 6, sm: 12, md: 6}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: sCell ? 16 : 18}}>
                                        <MonetizationOn sx={{mt: 0.6, mb: -0.6, pr: 1}}/>
                                        {valor.nombre}
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        fontSize: 24,
                                        fontWeight: 700,
                                        lineHeight: 1.1,
                                    }}>
                                        {formatoMoneda(valor.valor)}
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Typography sx={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        lineHeight: 1.1,
                                        color: theme.palette.secondary.main
                                    }}>
                                        {valor.texto}
                                    </Typography>
                                </Grid>

                            </Grid>
                        ))}

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', mt: 2, borderTop: 1, pt: 1}}>
                            <Typography sx={{fontSize: 18, fontWeight: 700}}>Formulario de Pre-Inscripción</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: 2, mb: 1}}>
                            <Formulario_Inscripcion props={props}/>
                        </Grid>

                        <Grid container size={1} sx={{justifyContent: 'flex-start'}}>
                            <Checkbox checked={acepto} onChange={() => setAacepto(!acepto)}/>
                        </Grid>

                        <Grid container size={11} sx={{justifyContent: 'flex-start', mt: 1, pl: sCell ? 2 : 1}}>
                            <Typography>Acepto política de tratamiento de datos</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2, mb: 1}}>
                            <Button
                                loading={cargando}
                                onClick={() => subirDatos()}
                            >Pre Incribirme</Button>
                        </Grid>

                    </Grid>


                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Educacion

const anuncios = [1]